import React from 'react';

import { OnboardCard } from '../../onboard-card';
import { CheckoutRatesCardBody } from './checkout-rates-card-body';
import { CheckoutRatesCardFooter } from './checkout-rates-card-footer';
import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';

import { messages } from '../../messages';

export const CheckoutRatesCard = () => {
  const { isCheckoutRatesComplete } = useHomePageOnboardContext();
  const title = isCheckoutRatesComplete ? messages.checkoutRatesTitleComplete : messages.checkoutRatesTitleIncomplete;
  return (
    <OnboardCard isComplete={isCheckoutRatesComplete} title={title}>
      <CheckoutRatesCardBody />
      <CheckoutRatesCardFooter />
    </OnboardCard>
  );
};
